export const environment = {
  production: false,
  appName: 'Risk Assessment CoPilot',
  platformUrl: 'https://bp-dev-apim.azure-api.net/pf-dev/',
  app_id: 'rac-dev',
  apimUrl: 'https://bp-dev-apim.azure-api.net/rac-dev',
  platformSupportUrl: 'https://bp-dev-apim.azure-api.net/pf-dev-lib/',
  apiPrefix: 'api',
  version: 'v1',
  pingMapsBaseUrl: 'https://app.pingintel.com/maps/',
};
